import { render, staticRenderFns } from "./ParcelTransactionsSection.vue?vue&type=template&id=34cbb744&scoped=true&"
import script from "./ParcelTransactionsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelTransactionsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTransactionsSection.vue?vue&type=style&index=0&id=34cbb744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbb744",
  null
  
)

export default component.exports